import { MAX_AUDIT_LOG_LENGTH } from "./pricing-constants";

export const createAsyncHandler = (builder, thunk, options = {}) => {
  const {
    loadingState = "isLoading",
    onFulfilled,
    onRejected = null,
  } = options;

  builder
    .addCase(thunk.pending, (state) => {
      state[loadingState] = true;
      state.message = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[loadingState] = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state[loadingState] = false;
      state.message = action.payload ?? action.error.message;
      if (onRejected) onRejected(state, action);
    });
};

export const addAuditEntry = (state, action, actionType, details) => {
  state.lastChanges.unshift({
    action: actionType,
    details,
    timestamp: new Date().toISOString(),
  });
  if (state.lastChanges.length > MAX_AUDIT_LOG_LENGTH) {
    state.lastChanges.pop();
  }
};

export const updateConfigByLocality = (state, newConfig) => {
  if (!newConfig?.localityType) return;

  const index = state.configs.findIndex(
    (c) => c.localityType.toLowerCase() === newConfig.localityType.toLowerCase()
  );

  if (index >= 0) {
    state.configs[index] = newConfig;
  } else {
    state.configs.push(newConfig);
  }
};

export const extractResponseData = (payload) => {
  return Array.isArray(payload) ? payload : (payload?.data ?? payload);
};

export const ensureArray = (data) => {
  return Array.isArray(data) ? data : [];
};

export const handleLegacyConfigResponse = (payload) => {
  const data = extractResponseData(payload);
  return ensureArray(data);
};
